import React from 'react'
import { useEffect, useState } from 'react'
import { Table, Space, Pagination, Input, Col, Row, Divider, Image, Modal, Checkbox, Button } from 'antd'
import { isEmpty, size, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import {
   CONFIG_URL,
   DATE_TIME_FORMAT_CLIENT_short,
   DATE_TIME_FORMAT_CLIENT_short2,
   PAGE_SIZE,
   ROLE,
   STATUS_ACTIVITY,
   getPage,
   getStatusText
} from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import AssignJob from './AssignJob'
// import Detail from './Detail'
import useWindowDimensions from '../../common/useWindowDimensions'
import Filter from 'src/common/components/Filter/Filter'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { DATE_TIME_FORMAT_CLIENT } from '../../helpers/constants'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { EditJobDetailModal } from '../job-detail/EditJobDetailCreator'
import { formatCurrency } from 'src/helpers/functions'
import useModal from 'src/helpers/modal/useModal'
import DetailCreator from '../creator-management/Detail'
import DetailDesigner from '../designer-management/Detail'
import theme from 'src/helpers/theme'

const JobManagement = observer((props: any) => {
   const { t } = useTranslation()
   const JobsStore = useStore('JobsStore')
   const JobDetailStore = useStore('JobDetailStore')
   // const CommonConfigStore = useStore('CommonConfigStore')
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   // const { designTypesList, productTypesList } = CommonConfigStore
   const [visible, setVisible] = useState(false)
   const [textSearch, set_textSearch] = useState('')
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [isLoading, setIsLoading] = useState(false)
   const { height } = useWindowDimensions()
   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [visibleFilter, setVisibleFilter] = useState(false)
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   // const [status, setStatus] = useState(POSITION_INFO.ALL.id)
   // const history = useHistory()
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const [statusObj, setStatusObj] = useState<any>({
      new: [STATUS_ACTIVITY.NEW],
      doing: [STATUS_ACTIVITY.DOING],
      review: '',
      finish: '',
      reject: [STATUS_ACTIVITY.REJECT]
   })
   const { jobTotal } = JobsStore
   const { rows, offset, count } = JobsStore.jobs
   const [isOpenEditJobDetail, setIsOpenEditJobDetail] = useState(false)
   const [selectedItem, setSelectedItem] = useState<any>([])

   const [visibleAssign, setVisibleAssign] = useState<any>(false)
   const [itemUser, setItemUser] = useState<any>(null)
   const [itemDesigner, setItemDesigner] = useState(null)
   const [itemCreator, setItemCreator] = useState(null)
   const [visibleUserDetailCreator, setVisibleUserDetailCreator] = useState<any>(false)
   const [visibleUserDetailDesigner, setVisibleUserDetailDesigner] = useState<any>(false)
   const { confirm } = useModal()

   useEffect(() => {
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusResult } })
      // JobsStore.getJobTotal(statusResult)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch])

   const onSubmitFilter = (value: any) => {
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()
      // console.log('statusNow: ', statusObj, 'statusResult; ', statusResult)
      // setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      setFieldFilter({ ...fieldFilter, ...value, ...{ status: statusResult } })
      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...value, ...{ status: statusResult } })
   }

   const onResetFilter = () => {
      const page = 0
      setFieldFilter({})
      getListData(0, { ...{ text: trim(textSearch) } })
   }

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage, PAGE_SIZE)
         const params = { offset, ...param }

         await JobsStore.getJobListAdmin(params)
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      // console.log('currentPage;', currentPage, 'currentPage-1', currentPage - 1)
      const statusResult = [
         ...statusObj.new,
         ...statusObj.doing,
         ...statusObj.review,
         ...statusObj.reject,
         ...statusObj.finish
      ].toString()

      getListData(currentPage - 1, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusResult } })
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const handleShowDetail = (item: any) => {
      setSelectedItem(item)
      JobDetailStore.setJobDetail(item)
      setIsOpenEditJobDetail(true)
   }

   const handleAssignJob = (item: any) => {
      setSelectedItem(item)
      JobDetailStore.setJobDetail(item)
      setVisibleAssign(true)
   }

   const handleCloseAssign = () => {
      setVisibleAssign(false)
   }
   const openEditJobModal = () => {
      setIsOpenEditJobDetail(true)
   }

   const closeEditJobModal = () => {
      setIsOpenEditJobDetail(false)
   }

   const onChangeStatus = (key: string | number, e: any) => {
      // let notOrder = OrderStore.optionSearchOrderCustomer.status.includes(1) ? [1] : []
      // let placingData = OrderStore.optionSearchOrderCustomer.status.includes(2) ? [2] : []
      // let orderFinish = OrderStore.optionSearchOrderCustomer.status.includes(3) ? [3] : []
      // let soldOut = OrderStore.optionSearchOrderCustomer.status.includes(4) ? [4] : []
      let statusNow = { ...statusObj }
      switch (key) {
         case STATUS_ACTIVITY.NEW:
            if (e.target.checked) {
               statusNow.new = [STATUS_ACTIVITY.NEW]
            } else {
               statusNow.new = []
            }
            break
         case STATUS_ACTIVITY.DOING:
            if (e.target.checked) {
               statusNow.doing = [STATUS_ACTIVITY.DOING]
            } else {
               statusNow.doing = []
            }
            break
         case STATUS_ACTIVITY.REVIEW:
            if (e.target.checked) {
               statusNow.review = [STATUS_ACTIVITY.REVIEW]
            } else {
               statusNow.review = []
            }
            break
         case STATUS_ACTIVITY.REJECT:
            if (e.target.checked) {
               statusNow.reject = [STATUS_ACTIVITY.REJECT]
            } else {
               statusNow.reject = []
            }
            break
         default:
            if (e.target.checked) {
               statusNow.finish = [STATUS_ACTIVITY.FINISH]
            } else {
               statusNow.finish = []
            }
            break
      }
      setStatusObj(statusNow)
      // let dataStatus = [...placingData, ...notOrder, ...orderFinish, ...soldOut]
      // OrderStore.setOptionSearchOrderCustomer({ status: dataStatus })

      const statusResult = [
         ...statusNow.new,
         ...statusNow.doing,
         ...statusNow.review,
         ...statusNow.reject,
         ...statusNow.finish
      ].toString()
      // console.log('statusNow: ', statusNow, 'statusResult; ', statusResult)
      setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
      getListData(0, { ...fieldFilter, ...{ text: trim(textSearch) }, ...{ status: statusResult } })
   }

   const handleDeleteJob = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonxoabanghi),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await JobsStore.deleteJob(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }
   const handlePriority = async (value: any, status: boolean, index: number) => {
      try {
         const res = await JobDetailStore.setJobPriority(value?.id, status)
         console.log('res', res)
         if (res) {
            // Sửa dữ liệu offline
            JobsStore.action_updateJobPriority(index, status)
         }
      } catch (error) {
         console.log(error)
      } finally {
      }

      // confirm({
      //    title: t(GLOBAL_CLIENT.setuutien),
      //    icon: <ExclamationCircleOutlined />,
      //    okText: t(GLOBAL_CLIENT.dongy),
      //    cancelText: t(GLOBAL_CLIENT.huy),
      //    onCancel() {},
      //    async onOk() {
      //       await JobDetailStore.setJobPriority(value?.id)
      //       if (size(trim(textSearch)) > 0) {
      //          getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      //       } else {
      //          getListData(0, { ...fieldFilter })
      //       }
      //    }
      // })
   }
   const handleEditDesigner = () => {
      // handle_getListData(page)
      hideDetailDesigner()
   }
   const handleEditCreator = () => {
      // handle_getListData(page)
      hideDetailCreator()
   }
   const hideDetailDesigner = () => {
      setVisibleUserDetailDesigner(false)
      setItemDesigner(null)
   }
   const hideDetailCreator = () => {
      setVisibleUserDetailCreator(false)
      setItemCreator(null)
   }

   const showDetailCreator = (item: any) => () => {
      setItemCreator(item)
      setTimeout(() => {
         setVisibleUserDetailCreator(true)
      }, 300)
   }
   const showDetailDesigner = (item: any) => () => {
      setItemDesigner(item)
      setTimeout(() => {
         setVisibleUserDetailDesigner(true)
      }, 300)
   }

   const handleCancelJob = (value: any) => {
      confirm({
         title: t(GLOBAL_CLIENT.banmuonhuyjob),
         icon: <ExclamationCircleOutlined />,
         okText: t(GLOBAL_CLIENT.dongy),
         cancelText: t(GLOBAL_CLIENT.huy),
         onCancel() {},
         async onOk() {
            await JobsStore.cancelJob(value?.id)
            if (size(trim(textSearch)) > 0) {
               getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
            } else {
               getListData(0, { ...fieldFilter })
            }
         }
      })
   }

   const columns = [
      // {
      //     title: t(GLOBAL_CLIENT.sothutu),
      //     dataIndex: "index",
      //     key: "index",
      //     align: "center" as "center",
      //     width: 80,
      //     // fixed: 'left',
      //     render: (value: string, record: any, index: number) =>
      //         (page-1) * PAGE_SIZE + index + 1,
      // },
      {
         title: t(GLOBAL_CLIENT.id),
         dataIndex: 'name',
         key: 'name',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: t(GLOBAL_CLIENT.txtDateTime),
         dataIndex: 'createdAt',
         key: 'createdAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: 'Cập nhật cuối',
         dataIndex: 'updatedAt',
         key: 'updatedAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.image),
         dataIndex: 'images',
         width: 80,
         key: 'images',
         render: (value: any) => {
            return (
               <Image
                  style={{ objectFit: 'contain' }}
                  height={30}
                  preview={{
                     mask: null
                  }}
                  fallback="data:image/png;base64,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"
                  src={`${CONFIG_URL.IMAGE_URL + '/' + value[0]?.path}`}
               />
            )
         }
      },
      {
         title: t(GLOBAL_CLIENT.creator),
         dataIndex: 'creator',
         width: 80,
         key: 'creator',
         render: (value: any) => {
            return (
               <span onClick={showDetailCreator(value)} className="gx-link txtMax2Line">
                  {value?.name || value?.email}
               </span>
            )
         }
         // render: (value: any) => {
         //    return <span className="txtMax2Line">{value?.name || ''}</span>
         // }
      },
      {
         title: t(GLOBAL_CLIENT.designer),
         dataIndex: 'designer',
         width: 80,
         key: 'designer',
         render: (value: any) => {
            return (
               <span onClick={showDetailDesigner(value)} className="gx-link txtMax2Line">
                  {value?.name || value?.email}
               </span>
            )
         }
         // render: (value: any) => {
         //    return <span className="txtMax2Line">{value?.name || ''}</span>
         // }
      },
      {
         title: 'Target',
         dataIndex: 'targetId',
         width: 60,
         key: 'targetId',
         render: (value: any, row: any) => {
            return (
               <Checkbox
                  defaultChecked={!isEmpty(row?.targetId) || !isEmpty(row?.targetIdSave)}
                  disabled={true}
               ></Checkbox>
            )
         }
      },
      {
         title: t(GLOBAL_CLIENT.designType),
         dataIndex: 'designType',
         width: 80,
         key: 'designType',
         render: (value: any) => {
            return <span className="txtMax2Line">{value?.name || ''}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.productType),
         dataIndex: 'productType',
         width: 80,
         key: 'productType',
         render: (value: any) => {
            return <span className="txtMax2Line">{value?.name || ''}</span>
         }
      },
      {
         title: 'SL mẫu',
         dataIndex: 'count',
         width: 45,
         key: 'count',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.txtPrice) + '(VND)',
         dataIndex: 'price',
         width: 80,
         key: 'price',
         render: (value: any) => {
            return <span className="txtMax2Line">{formatCurrency(value, true)}</span>
         }
      },
      {
         title: t(GLOBAL_CLIENT.status),
         dataIndex: 'status',
         width: 80,
         key: 'status',
         render: (value: any) => {
            return <span className="txtMax2Line">{getStatusText(value)}</span>
         }
      },
      {
         title: 'Việc ưu tiên',
         key: 'isPriority',
         width: 80,
         align: 'center' as 'center',
         // fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            return (
               <Checkbox
                  defaultChecked={record?.isPriority}
                  disabled={record?.status !== STATUS_ACTIVITY.NEW}
                  onChange={(e) => onChangePriority(record, e, index)}
               >
                  {/* {t(GLOBAL_CLIENT.priority)} */}
               </Checkbox>
            )
         }
      },
      {
         title: 'Action',
         key: 'action',
         width: 110,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            return (
               <span className="txtMax2Line">
                  {record?.status === STATUS_ACTIVITY.NEW && <AssignJob detail={record} indexItem={index} />}
                  <span onClick={() => handleShowDetail(record)} className="gx-link txtMax2LineHover">
                     {t(GLOBAL_CLIENT.detail)}
                  </span>

                  <Divider type="vertical" />
                  <span onClick={() => handleCancelJob(record)} className="gx-link txtMax2LineHover">
                     {t(GLOBAL_CLIENT.huy)}
                  </span>
                  {data_getUserInfo?.role !== ROLE.SUPPORTER && (
                     <>
                        <Divider type="vertical" />
                        <span onClick={() => handleDeleteJob(record)} className="gx-link txtMax2LineHover">
                           {t(GLOBAL_CLIENT.delete)}
                        </span>
                     </>
                  )}
               </span>
            )
         }
      }
   ]

   const onChangePriority = (item: any, e: any, index: number) => {
      console.log('item: ', item, 'e', e, 'inde', index)
      // setRememberMe(e.target.checked)
      handlePriority(item, e.target.checked, index)
   }

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   return (
      <>
         {/* <Loading isLoading={isLoading} /> */}
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={8}>
                     <Input.Search
                        onSearch={handleChangeTextSearch}
                        placeholder={t(GLOBAL_CLIENT.search)}
                        allowClear
                        enterButton
                     />
                  </Col>
                  <Col xs={24} md={2}>
                     {/* <Button type="primary" className="btn-add" onClick={handleFilter}>
                        <i className="icon icon-filter icon-in-button" />
                        {t(GLOBAL_CLIENT.filter)}
                     </Button> */}
                     <Filter onSubmitFilter={onSubmitFilter} onResetFilter={onResetFilter} />
                  </Col>
                  {/* <Col xs={24} md={12}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder={t(GLOBAL_CLIENT.search)} allowClear />
                  </Col> */}
                  <Col xs={24} md={14}>
                     <div className="text-right">
                        <Space>
                           <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng SL mẫu</span>
                              <span
                                 style={{ fontSize: 20, color: theme.color.primary, fontWeight: 'bolder' }}
                              >{`${formatCurrency(jobTotal?.count, true)}`}</span>
                           </Button>
                           <Button className="btn-add">
                              <span style={{ fontWeight: 'bold', paddingRight: 8 }}>Tổng tiền</span>
                              <span style={{ fontSize: 20, color: '#89AD88', fontWeight: 'bolder' }}>{`${formatCurrency(
                                 jobTotal?.price,
                                 true
                              )} VND`}</span>
                           </Button>
                        </Space>
                     </div>
                  </Col>
               </Row>
               <Space
                  className="total-items"
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
               >
                  <div>
                     {t(GLOBAL_CLIENT.totalItems)}: {count}
                  </div>
                  <div>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.NEW, e)}
                     >
                        {'Mới'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.DOING, e)}
                     >
                        {'Đang xử lí'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={false}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REVIEW, e)}
                     >
                        {'Review'}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REJECT, e)}
                     >
                        {t(GLOBAL_CLIENT.cansualai)}
                     </Checkbox>
                     <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={false}
                        onChange={(e) => onChangeStatus(STATUS_ACTIVITY.FINISH, e)}
                     >
                        {'Hoàn thành'}
                     </Checkbox>
                  </div>
               </Space>
               {/* <Space className="total-items">
                  {t(GLOBAL_CLIENT.totalItems)}: {count}
               </Space> */}

               <Table
                  scroll={{ x: 1500, y: height - 280 }}
                  columns={columns}
                  dataSource={rows}
                  rowKey="id"
                  pagination={false}
               />

               {renderPagination()}
            </Col>
         </Row>
         {itemDesigner && visibleUserDetailDesigner && (
            <DetailDesigner
               visible={visibleUserDetailDesigner}
               item={itemDesigner}
               onOk={handleEditDesigner}
               onCancel={hideDetailDesigner}
               onlyView
            />
         )}
         {itemCreator && visibleUserDetailCreator && (
            <DetailCreator
               visible={visibleUserDetailCreator}
               item={itemCreator}
               onOk={handleEditCreator}
               onCancel={hideDetailCreator}
               onlyView
            />
         )}

         {/* {item && <Detail visible={visibleDetail} item={item} onOk={handleEdit} onCancel={hideDetail} />} */}
         {/* <Filter visible={visibleFilter} onOk={confirmFilter} onCancel={hideFilter} /> */}
         <EditJobDetailModal
            data={selectedItem}
            visible={isOpenEditJobDetail}
            handleOk={openEditJobModal}
            handleCancel={closeEditJobModal}
         />
      </>
   )
})

export default JobManagement
